import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

// const loadingImage = require('~/assets/images/skeleton-loading.gif')

Vue.use(VueLazyload, {
  preLoad: 1.3, // default is 1.3
  // loading: loadingImage,
  attempt: 3, // default is 3
  adapter: {
    loaded({ el }) {
      el.dispatchEvent(new CustomEvent('loaded'))
    },
    loading({ el }) {
      el.classList.add('bg-gray-100')
      el.classList.add('animation-pulse')
    },
    error({ el }) {
      el.dispatchEvent(new CustomEvent('error'))
    }
  }
})
